import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { NumericFormat } from "react-number-format";

function AddConvenioSempapel() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [form, setForm] = useState({
    objeto: "",
    objeto_completo: "",
    parlamentar: "",
    cp_dl_tp: "",
    contrato: "",
    numero_convenio: "",
    numero_demanda: "",
    ano: "",
    repasse_convenio: "",
    contra_convenio: "",
    ass_termo: "",
    vigencia_convenio: "",
    vigencia_contrato: "",
  });

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/conveniossempapel/${id}`)
        .then((res) => {
          setForm(res.data);
        })
        .catch((err) => {
          console.error("Erro ao buscar dados:", err);
          alert("Erro ao carregar convênio");
        });
    }
  }, [id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleValueChange = (name, values) => {
    const { value } = values;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const url = id
      ? `/api/conveniossempapel/${id}`
      : "/api/conveniossempapel";

    const method = id ? "put" : "post";

    axios[method](url, form)
      .then((res) => {
        if (res.data.Status === "Success") {
          alert(
            id
              ? "Convênio SEMPAPEL atualizado com sucesso!"
              : "Convênio SEMPAPEL criado com sucesso!"
          );
          navigate("/conveniossempapel");
        } else {
          alert("Erro ao salvar convênio");
        }
      })
      .catch((err) => {
        console.error("Erro:", err);
        alert("Erro no servidor");
      });
  };

  return (
    <div className="px-4 py-3">
      <h3 className="mb-4">
        {id ? "Editar Convênio SEMPAPEL" : "Adicionar Convênio SEMPAPEL"}
      </h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Objeto</label>
          <input
            type="text"
            name="objeto"
            className="form-control"
            
            value={form.objeto}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Objeto Completo</label>
          <input
            type="text"
            name="objeto_completo"
            className="form-control"
            
            value={form.objeto_completo}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Parlamentar</label>
          <input
            type="text"
            name="parlamentar"
            className="form-control"
            value={form.parlamentar}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>CP/DL/TP</label>
          <input
            type="text"
            name="cp_dl_tp"
            className="form-control"
            value={form.cp_dl_tp}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Contrato</label>
          <input
            type="text"
            name="contrato"
            className="form-control"
            value={form.contrato}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Número do Convênio</label>
          <input
            type="text"
            name="numero_convenio"
            className="form-control"
            value={form.numero_convenio}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Número da Demanda</label>
          <input
            type="text"
            name="numero_demanda"
            className="form-control"
            value={form.numero_demanda}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Ano</label>
          <input
            type="text"
            name="ano"
            className="form-control"
            value={form.ano}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Repasse do Convênio</label>
          <NumericFormat
            name="repasse_convenio"
            className="form-control"
            thousandSeparator="."
            decimalSeparator=","
            prefix="R$ "
            value={form.repasse_convenio}
            onValueChange={(values) =>
              handleValueChange("repasse_convenio", values)
            }
          />
        </div>

        <div className="mb-3">
          <label>Contrapartida do Convênio</label>
          <NumericFormat
            name="contra_convenio"
            className="form-control"
            thousandSeparator="."
            decimalSeparator=","
            prefix="R$ "
            value={form.contra_convenio}
            onValueChange={(values) =>
              handleValueChange("contra_convenio", values)
            }
          />
        </div>

        <div className="mb-3">
          <label>Assinatura do Termo</label>
          <input
            type="date"
            name="ass_termo"
            className="form-control"
            value={form.ass_termo}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Vigência do Convênio</label>
          <input
            type="date"
            name="vigencia_convenio"
            className="form-control"
            value={form.vigencia_convenio}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Vigência do Contrato</label>
          <input
            type="date"
            name="vigencia_contrato"
            className="form-control"
            value={form.vigencia_contrato}
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="btn btn-primary">
          {id ? "Atualizar Convênio" : "Salvar Convênio"}
        </button>
      </form>
    </div>
  );
}

export default AddConvenioSempapel;
